import { useAppDispatch, useAppSelector } from './redux';
import { getSubscriptions } from 'applicaiton/store/reducers/ClinicOwner/ActionCreators';

export const useSubscription = () => {
  const dispatch = useAppDispatch();

  const { isExpiredSoon, isBlocked } = useAppSelector(
    (state) => state.clinicOwnerSlice,
  );

  const getSubscriptionsData = async () => {
    await dispatch(getSubscriptions());
  };

  return {
    isExpiredSoon,
    isBlocked,
    getSubscriptionsData,
  };
};
